<template>
  <nav-bar title="检查" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="check">
      首次检查：<span style="color: blue;text-decoration: underline;" @click="handleResClick(detail.fresult)">{{detail.fresult === '1' ? '已完成' : '未完成'}}</span>
      <div v-if="detail.fresult === '1'">完成时间： {{detail.flastCheckDate}}</div>
    </div>
    <div class="check">
      例行检查次数<span>{{detail.rresult}}</span>
      <div>
        <van-button type="primary" size="small" block :to="`/inspection/02/${detail.rcheckId}/${detail.userId}`">检查</van-button>
      </div>
    </div>
    <ul class="list">
      <li @click="$router.push(`/inspectionResults/${item.crId}`)" class="list-item" v-for="item in detail.rcheckResultList" :key="item.crId">
        <div class="list-item__title">{{item.ctitle || ''}}</div>
        <div>{{item.crChecktime}}</div>
      </li>
    </ul>
    <div class="check">
      专项检查： 应检查次数{{detail.splanCount}} 实际完成次数{{detail.sresult}}
    </div>
    <ul class="list">
      <li class="list-item" @click="item.crId ? $router.push(`/inspectionResults/${item.crId}`) : $router.push(`/inspection/03/${item.cid}/${detail.userId}`)" v-for="item in detail.scheckResultList" :key="item.crId">
        <div class="list-item__title">{{item.ctitle || ''}}</div>
        <div>{{item.crId ? '完成' : '未完成'}} <span v-if="item.crId">{{item.crChecktime}}</span></div>

      </li>
    </ul>
  </Content>
</template>

<script>
import { ref } from 'vue'
import { getAllCheckResultByUserId } from '@/api/salehome'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useRouter } from 'vue-router'
export default {
  name: 'CheckDetail',
  props: ['userId'],
  setup(props) {
    const detail = ref({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getAllCheckResultByUserId,
      data => {
        detail.value = data
      },
      props.userId
    )
    getDataLoading()
    const router = useRouter()
    const handleResClick = (res) => {
      if (res === '1') {
        router.push(`/inspectionResults/${detail.value.fcheckResultId}`)
      } else {
        router.push(`/inspection/01/${detail.value.fcheckId}/${detail.value.userId}`
        )
      }
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      detail,
      handleResClick
    }
  }
}
</script>

<style lang="scss" scoped>
.check {
  padding: 16px;
  font-size: 14px;
  line-height: 24px;
}
.list {
  padding: 16px;
  font-size: 14px;
  color: #666;
  font-size: 12px;
  line-height: 24px;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    &__title{
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
  }
}
</style>
